import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import JisButton from "../../components/controls/jisButton";
import Pagenated from "../../components/pagenated";
import JisEmptyList from "../../components/controls/emptylist";
import JisTabButton from "../../components/controls/jisTabButton";
import { ExecutionSheriffNewModal } from "../../components/post-judgement/deputy-sheriff/ExecutionSheriffModal";
import SheriffVerificationModal from "../../components/post-judgement/deputy-sheriff/SheriffVerificationModal";
import { NoticeOfSaleFormModal } from "../../components/post-judgement/deputy-sheriff/NoticeOfSaleFormModal";
import ProcessSheriffModal from "../../components/post-judgement/deputy-sheriff/ProcessSheriffModal";
import SheriffAuctionDetails from "../../components/post-judgement/deputy-sheriff/SheriffAuctionDetails";
import { RecordAuctionModal } from "./RecordAuctionModal";
import {
  AuctionSummary,
  AuctionSummaryModal,
} from "../../components/post-judgement/deputy-sheriff/AuctionSummary";
const judgePostJudgementCases = [
  {
    id: 1,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦2,500,000",
    totalAuctionCollected: "₦2,200,000",
    governmentCommission: "₦220,000",
    auctioneerCommission: "N/A",
  },
  {
    id: 2,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦1,800,000",
    totalAuctionCollected: "₦1,650,000",
    governmentCommission: "₦165,000",
    auctioneerCommission: "₦82,500",
  },
  {
    id: 3,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦3,200,000",
    totalAuctionCollected: "₦2,900,000",
    governmentCommission: "₦290,000",
    auctioneerCommission: "₦145,000",
  },
  {
    id: 4,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦950,000",
    totalAuctionCollected: "₦850,000",
    governmentCommission: "₦85,000",
    auctioneerCommission: "N/A",
  },
  {
    id: 5,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦4,100,000",
    totalAuctionCollected: "₦3,800,000",
    governmentCommission: "₦380,000",
    auctioneerCommission: "₦190,000",
  },
  {
    id: 6,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
    judgementDebtAmount: "₦1,500,000",
    totalAuctionCollected: "₦1,400,000",
    governmentCommission: "₦140,000",
    auctioneerCommission: "₦70,000",
  },
];

const DeputySheriffPostJudgement = () => {
  const { type } = useParams();
  const { frequentData } = useContext(ShareContext);
  const [pageIndex, setPageIndex] = useState(0);
  const [tab, setTab] = useState("pending");
  const [pageSize, setPageSize] = useState(10);
  const [isExecutionModal, setIsExecutionModal] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isNoticeModalOpen, setIsNoticeModalOpen] = useState(false);
  const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);
  const [isAuctionedModalOpen, setIsAuctionedModalOpen] = useState(false);
  const [isAuctionSummaryModalOpen, setIsAuctionSummaryModalOpen] =
    useState(false);
  const [isAuctionDetailsModalOpen, setIsAuctionDetailsModalOpen] =
    useState(false);
  // Determine which data to show based on type
  const getCurrentData = () => {
    switch (type) {
      case "approve":
        return judgePostJudgementCases;
      case "warranty":
        return judgePostJudgementCases; // Add review data here
      case "inventory":
        return judgePostJudgementCases; // Add deposition data here

      default:
        return [];
    }
  };

  const getSectionTitle = () => {
    switch (type) {
      case "approve":
        return "Head of process cases";

      case "warranty" && tab === "assigned":
        return "Assigned Cases";

      default:
        return "Processed Cases";
    }
  };

  const currentData = getCurrentData();

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const onSearch = () => {};

  const isPending = tab === "pending";
  const isCompleted = tab === "completed";
  const isInventory = type === "inventory";
  const showStatusLevel =
    type === "approve" || (type === "warranty" && tab === "assigned");

  const getActionButton = () => {
    if (tab === "assigned") {
      return "Re-assign";
    } else if (isPending && !isInventory) {
      return "Assign";
    } else if (isPending && isInventory) {
      return "Process";
    } else if (tab === "pending") {
      return "Assign";
    } else if (tab === "auctioned") {
      return "Record";
    }

    return "Verify";
  };

  const handleAction = () => {
    if (type === "approve") {
      setIsScheduleModalOpen(true);
    } else if (type === "warranty") {
      setIsExecutionModal(true);
    } else if (isInventory && isPending) {
      setIsProcessModalOpen(true);
    } else if (type === "inventory" && tab === "auctioned") {
      setIsAuctionedModalOpen(true);
    }
  };

  const closeExecutionModal = () => {
    setIsExecutionModal(false);
  };
  return (
    <div>
      <CustomSearchSortHeader
        onSearch={onSearch}
        frequentData={frequentData}
        isSearchAndDateOnly
      />

      <div
        className={
          type !== "approve" ? "post-judgement-tab-export-container" : ""
        }
      >
        {type !== "approve" && (
          <div className="tab_section ds-tab-container">
            <JisTabButton
              isActive={isPending}
              title="Pending"
              isRoleBased={false}
              onClick={() => setTab("pending")}
            />
            {isInventory ? (
              <>
                <JisTabButton
                  isActive={tab === "auctioned"}
                  title="Auctioned"
                  isRoleBased={false}
                  onClick={() => setTab("auctioned")}
                />
                <JisTabButton
                  isActive={isCompleted}
                  title="Completed"
                  isRoleBased={false}
                  onClick={() => setTab("completed")}
                />
              </>
            ) : (
              <JisTabButton
                isActive={tab === "assigned"}
                title="Assigned"
                isRoleBased={false}
                onClick={() => setTab("assigned")}
              />
            )}
          </div>
        )}

        <div className="exportdiv">
          <img src={wordicon} style={{ cursor: "pointer" }} />
          <img src={excelicon} style={{ cursor: "pointer" }} />
          <img src={pdficon} style={{ cursor: "pointer" }} />
        </div>
      </div>

      <div className="tab_view">
        {currentData?.length === 0 && <JisEmptyList />}
        {currentData?.length > 0 && (
          <div className="table">
            <div className="section-cases">
              <span>{getSectionTitle()}</span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    {!isCompleted && (
                      <>
                        <th>Type</th>
                        <th className="col-medium">Judgement Date</th>
                      </>
                    )}
                    {showStatusLevel && <th className="col-medium">Status level</th>}
                    {isCompleted && (
                      <>
                        <th>Judgement debt amount</th>
                        <th>Total auction collected</th>
                        <th>Government commission</th>
                        <th>Auctioneer commission</th>
                      </>
                    )}
                    <th className="col-title">Details</th>
                    {!isCompleted && <th className="col-action">Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {currentData?.map((caseItem, index) => (
                    <tr key={index}>
                      <td>{caseItem.suitNumber}</td>
                      <td>{caseItem.caseTitle}</td>
                      {!isCompleted && (
                        <>
                          <td>{caseItem.type}</td>
                          <td>{Constants.displayDate(caseItem.judgementDate)}</td>
                        </>
                      )}
                      {showStatusLevel && <td>{caseItem.statusLevel}</td>}
                      {isCompleted && (
                        <>
                          <td>{caseItem.judgementDebtAmount}</td>
                          <td>{caseItem.totalAuctionCollected}</td>
                          <td>{caseItem.governmentCommission}</td>
                          <td>{caseItem.auctioneerCommission}</td>
                        </>
                      )}
                      <td>
                        <JisButton variant="plain">View</JisButton>
                      </td>
                      {!isCompleted && (
                        <td>
                          <JisButton onClick={handleAction} variant="plain">
                            {getActionButton()}
                          </JisButton>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagenated
              onChangePageSize={(k) => setPageSize(k)}
              size={pageSize}
              total={currentData.length}
              maxPage={20}
              onPick={onPagePick}
            />
          </div>
        )}

        {isExecutionModal && (
          <ExecutionSheriffNewModal handleCancel={closeExecutionModal} />
        )}
      </div>

      {isScheduleModalOpen && (
        <SheriffVerificationModal
          handleCancel={() => setIsScheduleModalOpen(false)}
        />
      )}
      {isNoticeModalOpen && (
        <NoticeOfSaleFormModal
          handleCancel={() => setIsNoticeModalOpen(false)}
        />
      )}

      {isProcessModalOpen && (
        <ProcessSheriffModal
          handleConfirm={() => {
            setIsProcessModalOpen(false);
            setIsNoticeModalOpen(true);
          }}
          handleCancel={() => setIsProcessModalOpen(false)}
        />
      )}

      {isAuctionedModalOpen && (
        <RecordAuctionModal
          handleCancel={() => setIsAuctionedModalOpen(false)}
          handleConfirm={() => {
            setIsAuctionedModalOpen(false);
            setIsAuctionDetailsModalOpen(true);
          }}
        />
      )}

      {isAuctionDetailsModalOpen && (
        <SheriffAuctionDetails
          handleCancel={() => {
            setIsAuctionDetailsModalOpen(false);
          }}
          handleNext={() => {
            setIsAuctionDetailsModalOpen(false);
            setIsAuctionSummaryModalOpen(true);
          }}
        />
      )}
      {isAuctionSummaryModalOpen && (
        <AuctionSummaryModal
          handleBack={() => {
            setIsAuctionSummaryModalOpen(false);
            setIsAuctionDetailsModalOpen(true);
          }}
        />
      )}
    </div>
  );
};

export default DeputySheriffPostJudgement;
